/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsColorARGB,
    ControlcenterMelcoModelsColorARGBFromJSON,
    ControlcenterMelcoModelsColorARGBFromJSONTyped,
    ControlcenterMelcoModelsColorARGBToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsThreadChartColor
 */
export interface ControlcenterMelcoModelsThreadChartColor {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    code?: string | null;
    /**
     * 
     * @type {ControlcenterMelcoModelsColorARGB}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    color?: ControlcenterMelcoModelsColorARGB;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    type?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    weight_list?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChartColor
     */
    product_name?: string | null;
}

export function ControlcenterMelcoModelsThreadChartColorFromJSON(json: any): ControlcenterMelcoModelsThreadChartColor {
    return ControlcenterMelcoModelsThreadChartColorFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsThreadChartColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsThreadChartColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : ControlcenterMelcoModelsColorARGBFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight_list': !exists(json, 'weight_list') ? undefined : json['weight_list'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_id': !exists(json, 'product_id') ? undefined : json['product_id'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
    };
}

export function ControlcenterMelcoModelsThreadChartColorToJSON(value?: ControlcenterMelcoModelsThreadChartColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'code': value.code,
        'color': ControlcenterMelcoModelsColorARGBToJSON(value.color),
        'type': value.type,
        'weight_list': value.weight_list,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'product_id': value.product_id,
        'product_name': value.product_name,
    };
}


